"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Device_UdiCarrier = exports.Device_UdiCarrierEntryTypeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_base64Binary_1 = require("../Scalar/RTTI_base64Binary");
var Device_UdiCarrierEntryTypeKind;
(function (Device_UdiCarrierEntryTypeKind) {
    Device_UdiCarrierEntryTypeKind["_barcode"] = "barcode";
    Device_UdiCarrierEntryTypeKind["_rfid"] = "rfid";
    Device_UdiCarrierEntryTypeKind["_manual"] = "manual";
    Device_UdiCarrierEntryTypeKind["_card"] = "card";
    Device_UdiCarrierEntryTypeKind["_selfReported"] = "self-reported";
    Device_UdiCarrierEntryTypeKind["_unknown"] = "unknown";
})(Device_UdiCarrierEntryTypeKind = exports.Device_UdiCarrierEntryTypeKind || (exports.Device_UdiCarrierEntryTypeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Device_UdiCarrier = t.recursion('IDevice_UdiCarrier', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        deviceIdentifier: t.string,
        _deviceIdentifier: RTTI_Element_1.RTTI_Element,
        issuer: RTTI_uri_1.RTTI_uri,
        _issuer: RTTI_Element_1.RTTI_Element,
        jurisdiction: RTTI_uri_1.RTTI_uri,
        _jurisdiction: RTTI_Element_1.RTTI_Element,
        carrierAIDC: RTTI_base64Binary_1.RTTI_base64Binary,
        _carrierAIDC: RTTI_Element_1.RTTI_Element,
        carrierHRF: t.string,
        _carrierHRF: RTTI_Element_1.RTTI_Element,
        entryType: (0, EnumType_1.createEnumType)(Device_UdiCarrierEntryTypeKind, 'Device_UdiCarrierEntryTypeKind'),
        _entryType: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_Device_UdiCarrier.js.map